export const TEXTS = {
  MODAL_TITLE: 'Изменение типа устройства',
  MODAL_DESCRIPTION: 'При изменении типа устройства вещание на текущем устройстве будет прервано.',
  MODAL_NOTE_ADDRESS: 'Адрес: ',
  MODAL_NOTE_DEVICE: 'Устройство: ',
  MODAL_BUTTON_SUBMIT: 'Дальше',
  MODAL_BUTTON_CANCEL: 'Отменить',
};
